import React, { useMemo } from 'react';
import { MobileDownloadIcon } from 'src/components/SuitesTable/components/mobileDownloadIcon';
import { variables } from 'src/Tenants';
import moment from 'moment/moment';
import { NextAppointment } from 'src/components/SuitesTable/cells/NextAppointment';
import { serviceRequestTableLocalTime } from 'src/helpers/validationHelper';
import { sortByNumberOrString } from '../Table/sorting';

const WarrantyDateCell = ({ data }: any) =>
  data.warrantyStartDate ? (
    <div style={{ textAlign: 'center' }}>
      {serviceRequestTableLocalTime(data.warrantyStartDate) === '01/01/0001'
        ? ''
        : serviceRequestTableLocalTime(data.warrantyStartDate)}
    </div>
  ) : null;

const SuiteNumberCell = ({ data, onSuiteClick }: any) => {
  return (
    <div
      onClick={() => onSuiteClick(data.id, 'view')}
      style={{ cursor: 'pointer' }}
    >
      {data && data.number}
    </div>
  );
};

const BuildingCell = ({ data }: any) => {
  const buildingName = useMemo(() => {
    return data.building || '';
  }, [data.building]);

  return (
    <div title={buildingName}>
      {buildingName}
    </div>
  );
};

const ServiceRequestsCell = ({ data }: any) => (
  <div
    title={`Walk-through: ${data.walkthroughServiceRequestsCount}, Other: ${data.normalServiceRequestsCount}`}
    style={{ textAlign: 'center' }}
  >
    {data.serviceRequests}
  </div>
);

const HomeOwnerCell = ({ data }: any) =>
  data.homeOwners && data.homeOwners.id ? (
    <div style={{ textAlign: 'center' }}>
      {data.homeOwners.firstname + ' ' + data.homeOwners.lastname}
    </div>
  ) : null;

const createSuitesTableColumns = (onSuiteClick: any, onToggleMobileSync: any) => [
  {
    label: '',
    accessor: 'mobileSyncAllowed',
    xsHide: true,
    style: { width: '1rem' },
    cell: (data: any) => (
      <MobileDownloadIcon property={data} onClick={()=>onToggleMobileSync(data.id, !data.mobileSyncAllowed)} />
    ),
  },
  {
    label: variables.Suite,
    sortable: true,
    accessor: 'number',
    cell: (data: any) => (
      <SuiteNumberCell data={data} onSuiteClick={onSuiteClick} />
    ),
  },
  {
    center: true,
    sortable: true,
    label: 'Building',
    accessor: 'building',
    sortingAlgorithm: sortByNumberOrString,
    cell: (data: any) => <BuildingCell data={data} />,
  },
  {
    center: true,
    xsHide: true,
    label: variables.serviceRequest + 's',
    accessor: 'serviceRequests',
    cell: (data: any) => <ServiceRequestsCell data={data} />,
  },
  {
    center: true,
    label: variables.homeOwner,
    cell: (data: any) => <HomeOwnerCell data={data} />,
  },
  {
    center: true,
    xsHide: true,
    label: 'Status',
    accessor: 'status',
  },
  {
    center: true,
    xsHide: true,
    label: 'Warranty Start Date',
    cell: (data: any) => <WarrantyDateCell data={data} />,
  },
  {
    center: false,
    xsHide: true,
    label: 'Appointment',
    sortable: true,
    accessor: 'nextAppointment',
    sortingAlgorithm: (a, b) => {
      if (a === null) return 1;
      if (b === null) return -1;
      try {
        const parsedJsonA: any = JSON.parse(a);
        const parsedJsonB: any = JSON.parse(b);
        return moment(parsedJsonA?.timeStamp).diff(parsedJsonB?.timeStamp);
      } catch {
        return 0;
      }
    },
    cell: (data: any) => (
      <NextAppointment nextAppointment={data.nextAppointment} />
    ),
  },
];

export { createSuitesTableColumns };
